import type { ProjectTableItem } from "@kontextwerk/control-web-client"
import { request } from "../client"

export const fetchOrganizationProjectTable = (
  organizationId: string,
): Promise<ProjectTableItem[]> =>
  request<ProjectTableItem[]>(
    `/organizations/${encodeURIComponent(organizationId)}/projects?projection=table`,
  )
